import { render, staticRenderFns } from "./BasicsTransfer.vue?vue&type=template&id=06106a3e&scoped=true&"
import script from "./BasicsTransfer.vue?vue&type=script&lang=javascript&"
export * from "./BasicsTransfer.vue?vue&type=script&lang=javascript&"
import style0 from "./BasicsTransfer.vue?vue&type=style&index=0&id=06106a3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06106a3e",
  null
  
)

export default component.exports